function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.35446 2.75313L13.5963 0.0806181C14.3873 -0.104012 15.2192 0.0313525 15.9109 0.457235C16.6026 0.883118 17.098 1.56502 17.2892 2.35446L19.9617 13.5963C20.0586 14.0052 20.0702 14.4296 19.9959 14.8431C19.9216 15.2567 19.7629 15.6505 19.5298 16H2.35196L0.0806181 6.44604C-0.104012 5.65503 0.0313525 4.82311 0.457235 4.13144C0.883118 3.43977 1.56502 2.94438 2.35446 2.75313V2.75313Z",
  fill: "#ED6C05"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.33032 7.349V12.1522H3.42063V10.1422H5.20924V12.1522H6.2929V7.349H5.20924V9.19504H3.42063V7.349H2.33032Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.674 10.7556C15.6978 10.6142 15.7098 10.4711 15.7098 10.3278C15.7098 9.46552 15.282 8.58911 14.1559 8.58911C12.9441 8.58911 12.3989 9.56873 12.3989 10.4493C12.3989 11.5396 13.0764 12.2238 14.2591 12.2238C14.6891 12.2319 15.1168 12.1593 15.52 12.0099L15.3777 11.2758C15.0666 11.374 14.7418 11.422 14.4156 11.4181C13.9095 11.4181 13.4676 11.2042 13.4326 10.7523L15.674 10.7556ZM13.4218 10.014C13.4501 9.72187 13.6357 9.30905 14.0918 9.30905C14.5912 9.30905 14.7044 9.751 14.7044 10.014H13.4218Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0606 12.1491H17.1426V10.3855C17.1421 10.3043 17.1494 10.2232 17.1643 10.1433C17.2358 9.81038 17.5063 9.59398 17.905 9.59398C18.0031 9.5942 18.1009 9.60368 18.1971 9.62228V8.60354C18.1218 8.59109 18.0454 8.58635 17.9691 8.58939C17.6362 8.58939 17.2067 8.8033 17.0286 9.30933H17.0003L16.9645 8.66763H16.0273C16.0423 8.96726 16.0565 9.30184 16.0565 9.81537V12.1491H16.0606Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.39494 7.15503C7.50507 7.15503 7.61272 7.18769 7.70429 7.24887C7.79586 7.31005 7.86722 7.39701 7.90937 7.49876C7.95151 7.6005 7.96254 7.71246 7.94105 7.82047C7.91957 7.92848 7.86654 8.02769 7.78867 8.10556C7.71079 8.18343 7.61158 8.23647 7.50357 8.25795C7.39556 8.27943 7.2836 8.26841 7.18186 8.22626C7.08012 8.18412 6.99316 8.11275 6.93197 8.02119C6.87079 7.92962 6.83813 7.82197 6.83813 7.71184C6.83813 7.56416 6.8968 7.42254 7.00122 7.31812C7.10564 7.21369 7.24727 7.15503 7.39494 7.15503Z",
  fill: "#FFE700"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.6821 11.3407H10.2264C10.7716 11.3407 11.0188 10.9911 11.0188 10.6266C11.0188 10.262 10.9921 9.43722 10.318 9.43722C9.54311 9.43722 9.66878 10.4609 9.67128 10.9969C9.67128 11.111 9.6796 11.2258 9.6821 11.3407V11.3407ZM6.83813 8.66235H7.95175V10.6266C7.95175 10.9903 8.154 11.3399 8.60094 11.3407C8.60094 10.456 8.60094 9.54625 8.57015 8.66235H9.50066C9.52174 8.83325 9.54033 9.00387 9.55642 9.17421C9.99588 8.29531 11.3817 8.4884 11.8477 9.23081C12.3288 9.99736 12.4928 12.1921 10.2264 12.1921H9.69791C9.70291 12.6374 9.70374 13.0844 9.70374 13.5305H8.59012C8.59012 13.1018 8.59012 12.6532 8.59595 12.1921C7.39245 12.188 6.83813 11.4231 6.83813 10.6266V8.66235V8.66235Z",
  fill: "white"
});

var SvgHiper = function SvgHiper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHiper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hiper.dbb5f46c.svg";
export { ForwardRef as ReactComponent };